<!-- 文字组件 -->
<template>
  <div>
    <div class="chat-card">
      <video 
        class="chat-player" 
        controls 
      >
        <source :src="cardData.videoUrl" type="video/mp4">
      </video>
      <div class="video-area" @click="onClick"></div>
    </div>
    <!-- 视频容器 -->
    <div 
      v-if="isShowVideo" 
      class="video-container"
      @click="closeVideo"
    >
      <video 
        ref="videoPlayer"
        class="video-player"
        controls 
      >
        <source :src="cardData.videoUrl" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatVideo',
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          
          isShowTime: true
        };
      }
    }
  },
  components: {
  },
  data() {
    return {
      isShowVideo: false
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onClick() {
      this.isShowVideo = true
      this.$nextTick(() => {
        this.$refs.videoPlayer.play();
      });
    },
    closeVideo() {
      this.$refs.videoPlayer.pause();
      this.isShowVideo = false
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  border-radius: 12px;
  // padding: 10px 12px;
  background: #CFECFF;
  box-sizing: border-box;
  position: relative;
  .chat-player {
    width: 100%;
    border-radius: 12px;
  }
  .video-area {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}

.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-player {
  width: 100%;
  max-height: 100%;
}
</style>
